import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

export const fileUrl = (path) =>
  path && path.startsWith("/") ? `${process.env.REACT_APP_BACKEND_URL}${path}` : path;

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => e?.msg || "").filter(Boolean).join(" ");
  return "Something went wrong. Please try again.";
}
